import axios from "../config/axios";
import Constants from "../data/Constants";

export const getUserCart = async (id) => {
  return await axios.get(Constants.ENDPOINTS.CART.SINGLE + id).then((res) => {
    return res.data.result;
  });
};
